import { TranslationKeys, PostProcessKeys } from 'translations';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import FormModal from 'v2/common/FormModal/FormModal';
import { DataProduct, DataProductRestriction } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import DataProductRestrictionForm, {
  DataProductRestrictionFormFields,
} from '../DataProductRestrictionForm/DataProductRestrictionForm';

interface EditDataProductRestrictionModalProps {
  itemToEdit: DataProductRestriction;
  dataProduct: DataProduct;
  onClose: () => void;
  reloadRestrictions: () => Promise<void>;
}

const EditDataProductRestrictionModal = ({
  itemToEdit,
  dataProduct,
  onClose,
  reloadRestrictions,
}: EditDataProductRestrictionModalProps) => {
  const { t } = useTranslation();
  const {
    mutate: dataProductRestrictionMutate,
    isLoading: isDataProductRestrictionMutateLoading,
  } = useMutation(
    async (data: DataProductRestrictionFormFields) => {
      await restFactory.patch<DataProductRestriction>(
        `/dj/api/v1/restrictions/${itemToEdit.id}/`,
        {
          ...data,
          data_product: dataProduct.id,
        }
      );
    },
    {
      onSuccess: () => {
        onClose();
        reloadRestrictions();
        toast.success('Restriction updated.');
      },
      onError: () => {
        toast.error('Error updating restriction.');
      },
    }
  );

  const formContext = useForm<DataProductRestrictionFormFields>({
    mode: 'onChange',
    defaultValues: {
      title: itemToEdit.title,
      restriction: itemToEdit.restriction,
    },
  });

  const onSubmit = (data: DataProductRestrictionFormFields) => {
    dataProductRestrictionMutate(data);
  };

  return (
    <FormModal
      title={`Edit ${t(TranslationKeys.dataProduct_one, {
        postProcess: PostProcessKeys.TitleCase,
      })} Restrictions`}
      onClose={onClose}
      onSubmit={onSubmit}
      isLoading={isDataProductRestrictionMutateLoading}
      formContext={formContext}
    >
      <DataProductRestrictionForm />
    </FormModal>
  );
};

export default EditDataProductRestrictionModal;
